export default function Event({ t }) {
  return (
    <>
      <h3 className='mb-3'>{t('event.name')}</h3>
      <p className='mb-0'>{t('event.address')}</p>
      <a
        href={t('event.location.link')}
        target={'_blank'}
        rel='noreferrer'
      >
        {t('event.location.text')}
      </a>

      <p className='mb-0'>{t('event.date')}</p>
      <p className='mb-0'>{t('event.time')}</p>
    </>
  );
}
